export const iconFontAwesomeHouseholdBlender = (
	<i className="fa-solid fa-blender"></i>
);
